import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithEnhypen = () => {
  return (
    <KpopStudyPageTemplate
      groupName="ENHYPEN"
      groupNameDisplay="ENHYPEN"
      fandomName="ENGENEs"
      seoTitle="Study With ENHYPEN - ENHYPEN Study Rooms"
      seoDescription="Study with ENHYPEN fans worldwide. Join ENGENEs in virtual study rooms with ENHYPEN playlists and productivity tools."
      seoKeywords="study with enhypen, enhypen study room, engene study, kpop study room"
      canonicalUrl="/study-with-enhypen/"
      heroDescription="Join a global community of ENGENEs who combine their passion for ENHYPEN with productive study sessions."
      aboutContent={
        <>
          <p>
            <a href="https://enhypen.weverse.io/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">ENHYPEN</a> is a South Korean boy band formed through the survival show I-LAND in 2020. Under BELIFT LAB, members Heeseung, Jay, Jake, Sunghoon, Sunoo, Jungwon, and Ni-ki have captured hearts worldwide.
          </p>
          <p>
            ENHYPEN's fanbase, known as ENGENE, represents the connection between the group and their fans. Follow them on <a href="https://www.instagram.com/enhypen/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/ENHYPEN" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@ENHYPEN" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          ENHYPEN fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/5t5FqBwTcgKTaLSV0xUe6w" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">ENHYPEN's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "ENHYPEN Study Playlists", desc: "Curated playlists featuring ENHYPEN's music to keep you motivated." },
        { title: "Connect with ENGENE", desc: "Meet fellow ENGENEs from around the world who share your passion." },
        { title: "Vampire-Themed Rooms", desc: "Study rooms with ENHYPEN-inspired dark academia aesthetics." },
        { title: "24/7 Study Sessions", desc: "Join study sessions anytime with other ENGENEs worldwide." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of ENHYPEN can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Weverse", url: "https://enhypen.weverse.io/" },
        { name: "YouTube", url: "https://www.youtube.com/@ENHYPEN" },
        { name: "Instagram", url: "https://www.instagram.com/enhypen/" },
        { name: "X (Twitter)", url: "https://twitter.com/ENHYPEN" },
        { name: "Spotify", url: "https://open.spotify.com/artist/5t5FqBwTcgKTaLSV0xUe6w" },
      ]}
      youtubeVideos={[
        { id: "WcNV8Ik0GsI", title: "ENHYPEN - XO (Only If You Say Yes) M/V" },
        { id: "0gVqnPfyXnA", title: "ENHYPEN - Bite Me M/V" },
        { id: "Cj8kG5O4aH0", title: "ENHYPEN - Sweet Venom M/V" },
        { id: "nyGVAV3n-Rg", title: "ENHYPEN - FEVER M/V" },
        { id: "b0ykPSzKxds", title: "ENHYPEN - Polaroid Love M/V" },
        { id: "6Y_0H0Xo4z8", title: "ENHYPEN - Drunk-Dazed M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@ENHYPEN"
      youtubeChannelName="ENHYPEN"
    />
  );
};

export default StudyWithEnhypen;
